import React from 'react';
import { ChatMessage } from '_helpers';
import cn from 'classnames';
import moment from 'moment';
import styles from './OnlineChat.module.scss';

const OnlineChatMessage = ({ message, isApplicant, expertId }: IProps) => {
    const isAuthor = (isApplicant && message.fromApplicant)
        || (!message.fromApplicant && message.expertId === expertId);
    const name = message.fromApplicant ? message.applicantName : (message.expertName || '');

    let shortName;
    if (isAuthor) {
        shortName = 'Вы';
    } else {
        const role = message.fromApplicant ? 'Соискатель' : 'Эксперт';
        shortName = name.split(' ')
            .map((word, num) => (num > 0 ? `${word.charAt(0)}.` : `${word} `))
            .concat(` (${role})`)
            .join('');
    }

    const nameInitials = name.split(' ').map(word => word.charAt(0)).slice(0, 2).join('');

    return (
        <div className={styles.chat_field}>
            <div
              className={cn(styles.chat_icon, {
                    [styles.blue]: !message.fromApplicant,
                    [styles.rose]: message.fromApplicant,
                })}
            >
                {nameInitials}
            </div>
            <div className={styles.chat_field_body}>
                <div className={styles.chat_userNameContainer}>
                    <span className={styles.chat_userName}>{shortName}</span>
                    <span className={styles.messageTime}>
                        {moment(message.created).format('HH:mm')}
                    </span>
                </div>
                <span className="d-block">
                    {message.message}
                </span>
            </div>
        </div>
    );
};

export default OnlineChatMessage;

interface IProps {
    message: ChatMessage;
    expertId?: string;
    isApplicant?: boolean;
}
